import { createReducer } from "@reduxjs/toolkit";
import * as actionTypes from "~/store/action_types";

const activityLogs = createReducer({}, (builder) => {
  builder
    .addCase(actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { activity_logs = {} } = entities;

      if (activity_logs) {
        return { ...state, ...activity_logs };
      }
      return state;
    })
    .addCase(actionTypes.CONVERT_DISCUSSION_TO_TASK_SUCCESS, (state, action) => {
      const filteredLogs = Object.values(state).filter(
        (log) => !(log.parent_id === action.discussionId && log.parent_type === "Discussion")
      );

      return filteredLogs.reduce((prev, next) => {
        prev[next.id] = next;
        return prev;
      }, {});
    })
    .addMatcher(
      (action) =>
        [actionTypes.PERMANENTLY_DELETE_LOADING, actionTypes.DATA_OBJECT_DELETED_SUCCESS].includes(action.type),
      (state, action) => {
        const { id, objectType } = action;
        const filteredActivityLogs = Object.values(state).filter(
          (item) => !(item.parent_id === id && item.parent_type === objectType)
        );

        return filteredActivityLogs.reduce((prev, next) => {
          prev[next.id] = next;
          return prev;
        }, {});
      }
    );
});

export default activityLogs;
